import React from 'react';

type Props = {
  color?: string;
};

function Logo(props: Props) {
  const color = props.color ? props.color : '#0082cb';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      version="1.1"
      viewBox="0 0 2024 1252"
    >
      <defs>
        <clipPath id="clipPath18" clipPathUnits="userSpaceOnUse">
          <path d="M0 1050.674h1620.176V0H0z"></path>
        </clipPath>
      </defs>
      <g transform="matrix(1.33333 0 0 -1.33333 0 1400.893)">
        <g transform="translate(-61.87 63.655)">
          <g clipPath="url(#clipPath18)">
            <g transform="translate(734.096 502.731)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0a9069.315 9069.315 0 0049.574 12.033l-3.216 11.826a18615.25 18615.25 0 01-29.147-6.663C14.818 10.435 9.843 3.77 0 0"
              ></path>
            </g>
            <g transform="translate(121.697 332.075)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c26.131 54.289 126.204 33.391 193.833 45.482C169.342-10.473 61.622 18.199 0 0m230.385 67.648c-5.452 1.67-9.227 5.473-11.015 11.104-2.465-7.763-8.688-12.072-17.906-12.072h-12.466c-12.138 0-19.1 7.456-19.1 20.455v13.336h6.699c-4.349 3.434-6.699 9.115-6.699 16.666v10.355l-9.947 8.373c-25.999 8.59-57.68 13.647-100.486 2.731-51.611-10.223-92.078-37.01-119.281-40.674 25.152-40.397 44.628-85.955 44.73-149.131 59.182 36.57 156.605 13.031 208.743 61.008 28.309 26.05 27.506 35.813 36.728 57.849"
              ></path>
            </g>
            <g transform="translate(1550.466 660.524)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c-28.93-.726-93.154-4.581-118.987-5.954-25.848-1.375-46.423 9.901-45.438 49.028a154.19 154.19 0 018.014-4.241c28.682-14.097 42.771-8.049 56.176 5.014 14.428 14.056 50.7 49.122 98.055 57.275.572.099 1.136.212 1.71.302-.105-.976-4.895-14.438-6.626-34.679a201.88 201.88 0 01-.331-10.159c-.061-8.955 1.74-24.232 3.409-36.311A594.932 594.932 0 010 0l.054.002C.694-2.985.563-2.572 0 0m19.887 48.192c-.282 24.586 1.599 49.021 3.444 72.327-16.781 2.062-24.704 7.914-80.264 5.89-30.466-1.11-65.082-3.43-101.272-30.2-9.897-8.259-22.95-21.405-27.46-37.35-4.511-15.943-5.496-41.269-13.651-50.414-5.919-6.637-59.275-19.671-121.819-37.097v-18.561l1.226.331c.358.526 3.944 1.694 9.118 3.153 2.311 11.645 10.876 25.024 38.047 25.024h30.805c7.602 0 13.738-1.055 18.698-2.818 14.688 3.668 26.581 6.477 34.327 8.035 53.476-17.608 119.486-12.805 218.306-11.541-6.79 23.902-9.227 48.636-9.505 73.221"
              ></path>
            </g>
            <g transform="translate(1542.81 708.665)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c.179-6.945 1.854-17.935 3.639-27.866C1.97-15.787.168-.509.229 8.446c.024 3.503.144 6.889.332 10.158A167.653 167.653 0 010 0"
              ></path>
            </g>
            <g transform="translate(875.54 536.48)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0v11.703a20691.62 20691.62 0 00-23.924-5.442L-27.369-6.41C-18.303-4.28-9.181-2.143 0 0"
              ></path>
            </g>
            <g transform="translate(1039.98 639.927)">
              <path
                fill={color}
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c3.344 0 6.395-.21 9.197-.587a549.704 549.704 0 0113.181 34.558c22.645 66.111 33.427 139.459 33.327 228.096C-2.65 189.952-71.673 123.796-158.358 90.497c32.208-26.461 61.921-57.008 88.499-90.93V0z"
              ></path>
            </g>
            <g transform="translate(864.98 724.515)">
              <path
                fill={color}
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0a335.974 335.974 0 00-41.638-10.728c38.686-21.367 72.784-46.124 102.727-73.86h21.235C57.287-52.441 29.621-24.002 0 0"
              ></path>
            </g>
            <g transform="translate(1119.162 801.474)">
              <path
                fill={color}
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c10.1 51.56 16.773 103.805 19.368 156.626a1635.205 1635.205 0 00-16.327-22.079C4.674 93.514 4.318 57.604 1.987 23.682A800.32 800.32 0 000 0"
              ></path>
            </g>
            <g transform="translate(1072.55 627.398)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c6.995 16.796 13.229 33.918 18.602 51.36 7.54 24.478 13.289 49.44 17.57 74.663 4.045 23.832 6.78 47.896 8.436 72.01 2.413 35.123 2.503 70.364 1.229 105.549-.53 14.65-1.292 29.291-2.231 43.909a2.041 2.041 0 01-.065.374c-.012.043-.029.088-.043.132a2.896 2.896 0 01-.175.44c-.043.09-.09.183-.141.277-.033.058-.066.118-.102.178a8.038 8.038 0 01-.189.297c-.039.059-.077.117-.119.177-.083.117-.172.238-.266.359l-.102.134c-.131.165-.271.333-.421.504-.045.052-.095.106-.142.158-.11.122-.221.244-.339.368-.066.07-.137.141-.205.212-.107.109-.215.218-.326.328-.076.075-.155.15-.234.226a26.367 26.367 0 01-1.222 1.104 31.491 31.491 0 01-1.343 1.091c-.086.067-.174.132-.261.199a42.044 42.044 0 01-1.205.882l-.306.214c-.156.108-.314.215-.473.321l-.289.194a43.23 43.23 0 01-.575.37l-.196.126c-.255.159-.512.315-.767.468l-.233.134a23.47 23.47 0 01-.549.316c-.097.055-.194.107-.291.16a26.085 26.085 0 01-1.273.661c-.098.048-.195.096-.293.142-.171.081-.34.158-.51.233-.081.037-.164.075-.245.11a20.191 20.191 0 01-.823.336c-.209.079-.414.154-.616.222-.08.028-.158.051-.237.076a12.667 12.667 0 01-.705.205 9.559 9.559 0 01-1.049.209c-.07.01-.142.021-.212.029a5.846 5.846 0 01-.447.027c-.039.001-.08.006-.117.006-.028 0-.054-.004-.082-.005a3.83 3.83 0 01-.539-.044c-.065-.01-.123-.026-.184-.039a2.568 2.568 0 01-.541-.182 1.924 1.924 0 01-.306-.187c-.044-.033-.09-.06-.131-.096a1.828 1.828 0 01-.339-.391C-28.406 274.43-89.349 186.852-180.923 141.725c-17.43-8.59-35.75-15.297-54.537-20.235-3.732-.981 3.76-7.112 4.491-7.66l.557-.414.181-.132c.14-.104.283-.208.432-.316l.25-.179c.136-.098.274-.196.416-.296l.289-.202a31.457 31.457 0 01.739-.501c.143-.097.29-.192.438-.289.11-.071.22-.143.332-.213.153-.098.31-.194.467-.291l.328-.201c.169-.101.341-.2.513-.299.102-.059.204-.119.307-.177.225-.125.452-.246.681-.365.052-.027.102-.057.154-.083.279-.143.559-.279.839-.408.091-.042.181-.079.272-.119.192-.085.385-.17.579-.247.111-.045.222-.085.334-.127.172-.065.344-.128.516-.186.118-.04.237-.075.355-.111a9.74 9.74 0 011.333-.319c.117-.02.233-.039.349-.054a7.98 7.98 0 01.482-.043c.109-.007.219-.016.327-.018.175-.003.347.006.518.017.085.005.17.005.254.014.254.028.502.07.744.133.677.179 1.351.368 2.027.551l.017.093c.404 1.903 1.865 3.361 3.909 3.901.755.2 1.56.301 2.395.301 1.63 0 3.314-.39 4.952-.997 42.435 13.412 80.88 36.509 114.539 65.704 38.18 33.114 69.759 73.229 98.373 114.674A1211.975 1211.975 0 0126.222 319.5c.515-13.307.827-26.626.905-39.94.471-79.41-7.605-158.653-33.535-234.356a550.344 550.344 0 00-12.928-33.962C-9.883 9.219-3.828 4.995 0 0"
              ></path>
            </g>
            <g transform="translate(867.673 735.401)">
              <path
                fill="#fff"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0l-.072.032.07-.033z"
              ></path>
            </g>
            <g transform="translate(862.915 736.648)">
              <path
                fill="#fff"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c-.135 0-.265-.015-.396-.023.17.011.343.02.519.016C.083-.006.04 0 0 0"
              ></path>
            </g>
            <g transform="translate(877.293 728.794)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c-.923.751-1.837 1.513-2.766 2.259a27.84 27.84 0 01-.537.423l-.211.161c-.127.096-.255.194-.389.294-.087.065-.179.131-.269.196-.128.094-.256.188-.39.283l-.301.212-.41.283-.321.215c-.142.095-.289.191-.436.286l-.333.213a53.867 53.867 0 01-.8.488c-.176.104-.355.206-.533.306l-.292.166c-.245.134-.492.264-.741.39l-.104.055c-.262.132-.524.256-.788.376l-.07.033c-.08.036-.161.068-.24.103-.207.09-.414.178-.621.259-.104.041-.21.078-.314.117-.183.068-.365.133-.547.193-.112.037-.224.07-.336.104-.174.051-.347.1-.519.144a10.289 10.289 0 01-.843.176c-.112.018-.223.036-.334.05a8.39 8.39 0 01-.494.045c-.105.006-.211.014-.315.016a5.924 5.924 0 01-.519-.016c-.083-.005-.167-.006-.248-.015a4.82 4.82 0 01-.73-.13c-1.505-.397-1.192-1.617-.235-2.971C-14.555 2.688-11.677.36-11.26.025c1.153-.927 2.291-1.87 3.435-2.807 30.928-25.334 58.54-54.437 82.914-86.086h12.325C61.565-56.282 32.391-26.381 0 0"
              ></path>
            </g>
            <g transform="translate(539.703 394.978)">
              <path
                fill={color}
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c-1.863-.486-3.906-.74-6.127-.74h-4.725l-.168-.373a482.3 482.3 0 01-6.653-5.901C6.861-24.598 31.467-38.802 56.326-49.68 36.363-34.742 17.576-18.016 0 0"
              ></path>
            </g>
            <g transform="translate(614.888 202.593)">
              <path
                fill={color}
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c-29.439-21.645-60.98-42.281-95.347-62.316 85.42 35.054 166.832 79.486 232.1 136.964-13.894 2.171-27.436 5.265-40.638 9.158C68.357 54.677 36.129 26.564 0 0"
              ></path>
            </g>
            <g transform="translate(647.007 312.748)">
              <path
                fill={color}
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c-19.289 4.639-38.524 10.918-57.571 18.835-27.392 11.386-54.433 26.137-80.67 43.978-52.585-50.966-97.102-115.592-133.551-182.639-14.209-35.324-27.056-73.32-38.638-114.246a2021.668 2021.668 0 0150.626 14.761c19.98 9.403 39.043 18.832 57.461 28.426C-97.586-136.313-19.929-81.08 40.086-18.28 26.317-13.038 12.954-6.91 0 0"
              ></path>
            </g>
            <g transform="translate(446.512 118.315)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0a1529.321 1529.321 0 00-32.673-16.5c-28.279-13.88-56.959-26.946-85.9-39.389a1386.531 1386.531 0 004.134 15.001c8.023 28.558 17.014 56.996 27.196 85.016 24.142 66.436 54.976 130.504 95.539 188.12a523.424 523.424 0 0034.525 43.895A510.28 510.28 0 0165.2 260.086c37.476-25.395 78.293-45.581 121.491-57.907 23.254-6.636 47.196-11 71.677-12.669a610.36 610.36 0 00-13.718-14.894C175.263 101.726 88.803 46.261 0 0m260.202 169.365a595.871 595.871 0 0119.147 20.946c3.202 3.677-8.6 5.65-10.129 5.687-37.436.894-72.713 8.432-106.041 21.166-31.965 12.214-62.131 29.22-90.686 49.738a508.482 508.482 0 00-14.202 10.575c-3.621-.155-34.875-.452-34.875-.452C-46.993 195.412-91.505 93.014-123.177-9.045c-5.809-18.719-11.132-37.586-16.061-56.555a2.428 2.428 0 01-.076-.564c-.001-.053.002-.104.004-.155.006-.136.025-.267.056-.394.01-.044.017-.089.03-.131.051-.161.118-.316.206-.463.016-.025.037-.048.053-.074.08-.122.173-.24.278-.353.037-.04.077-.079.117-.119.108-.105.226-.206.354-.301.033-.026.064-.053.098-.077.166-.118.347-.229.539-.333.047-.026.097-.049.144-.074a8.111 8.111 0 01.686-.311c.206-.081.418-.159.64-.232l.066-.023c.248-.079.508-.151.773-.221l.206-.05c.212-.051.429-.1.65-.146l.208-.043c.285-.055.573-.107.868-.152l.038-.006c.283-.043.571-.081.86-.116l.223-.025c.252-.028.505-.054.759-.076l.165-.015c.31-.025.62-.047.928-.063l.113-.006c.269-.014.537-.024.803-.031l.21-.006c.275-.007.548-.011.816-.011l.066-.001c.28 0 .555.004.824.01l.115.004c.22.006.436.013.646.023l.2.011c.182.01.359.02.531.033.064.005.13.009.193.015.202.015.396.033.582.053.021.002.044.003.065.006.205.023.397.047.579.074.051.007.097.015.145.023a10.714 10.714 0 01.519.094c.102.02.195.043.283.066l.123.031c.118.035.226.07.313.106 57.59 24.154 114.557 50.58 169.304 80.874C87.556 34.21 127.771 59.389 166.007 87.5c33.54 24.661 65.383 51.796 94.195 81.865"
              ></path>
            </g>
            <g transform="translate(372.99 575.722)">
              <path
                fill={color}
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0l27.448 56.455H-4.906L-29.998 5.17h-8.04v51.285h-35.28V-66.486h35.28v48.446h10.773l23.781-48.307.068-.139h36.083z"
              ></path>
            </g>
            <g transform="translate(476.797 612.056)">
              <path
                fill={color}
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0v-40.816h-24.591V0c0 .941.417 1.745 1.276 2.457.858.716 1.933 1.078 3.194 1.078H-4.47c1.257 0 2.332-.362 3.194-1.078C-.429 1.752 0 .925 0 0m4.225 22.014h-33.041c-20.607 0-31.056-8.489-31.056-25.231v-99.603h35.281v41.066H0v-41.066h35.28v99.603c0 16.742-10.448 25.231-31.055 25.231"
              ></path>
            </g>
            <g transform="translate(599.023 634.07)">
              <path
                fill={color}
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h-30.805c-20.607 0-31.056-8.488-31.056-25.23v-99.604h35.28V-22.96c0 .941.418 1.745 1.277 2.457.857.716 1.932 1.078 3.194 1.078h13.415c1.258 0 2.333-.362 3.194-1.078.858-.715 1.276-1.519 1.276-2.457v-101.874h35.28v99.604C31.055-8.488 20.607 0 0 0"
              ></path>
            </g>
            <g transform="translate(710.317 632.177)">
              <path
                fill={color}
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0v-101.875c0-.938-.417-1.742-1.275-2.457-.863-.716-1.938-1.078-3.195-1.078h-13.415c-1.261 0-2.336.362-3.195 1.078-.858.712-1.275 1.516-1.275 2.457V0h-35.281v-99.604c0-16.742 10.449-25.23 31.056-25.23H4.226c20.606 0 31.054 8.488 31.054 25.23V0z"
              ></path>
            </g>
            <g transform="translate(833.833 632.177)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0l-19.424-88.409L-38.807-.196-38.85 0h-34.314l33.376-122.757.05-.184H.642L33.981-.315l.086.315z"
              ></path>
            </g>
            <g transform="translate(958.25 610.102)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0v22.074h-73.786v-122.941H0v22.452h-38.507v28.833h36.024v21.316h-36.024V0z"
              ></path>
            </g>
            <g transform="translate(1013.152 613.698)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h18.133c1.257 0 2.332-.362 3.194-1.078.847-.705 1.277-1.532 1.277-2.457v-28.197c0-.938-.417-1.743-1.276-2.457-.863-.716-1.938-1.079-3.195-1.079H0zm57.884-20.945v14.193c0 16.742-10.448 25.231-31.056 25.231h-62.109v-122.942H0v50.15h16.395c3.007 0 4.469-1.157 4.469-3.535v-46.615h35.281v48.696c0 7.898-3.969 13.118-11.802 15.527 8.986 2.924 13.541 9.411 13.541 19.295"
              ></path>
            </g>
            <g transform="translate(1166.68 610.102)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0v22.074h-73.786v-122.941H0v22.452h-38.507v28.833h36.024v21.316h-36.024V0z"
              ></path>
            </g>
            <path
              fill="#1a1a18"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M1186.3 509.235h35.281v122.941H1186.3z"
            ></path>
            <g transform="translate(1308.527 634.07)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h-30.805C-51.412 0-61.86-8.488-61.86-25.23v-99.604h35.28V-22.96c0 .941.417 1.745 1.276 2.457.859.716 1.933 1.078 3.195 1.078h13.414c1.258 0 2.334-.362 3.194-1.078.859-.715 1.276-1.519 1.276-2.457v-101.874h35.281v99.604C31.056-8.488 20.607 0 0 0"
              ></path>
            </g>
            <g transform="translate(723.775 500.185)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0a64.545 64.545 0 00-4.412-.438 73.5 73.5 0 00-4.82-.154h-30.806c-2.635 0-5.095.126-7.391.364A54.324 54.324 0 00-53.838.809c-11.858-2.807-26.112-6.2-39.766-9.482-13.325-3.203-26.069-6.297-35.467-8.64h61.38c8.055 2.158 16.82 4.453 26.21 6.866A4849.489 4849.489 0 000 0"
              ></path>
            </g>
            <g transform="translate(323.16 449.134)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h-9.508c-.494 0-.899.188-1.239.573a1.983 1.983 0 00-.518 1.367v12.593c0 .526.169.973.518 1.368.34.385.745.572 1.239.572h5.811c.492 0 .897-.188 1.239-.572.349-.396.518-.843.518-1.368V8.698h14.55v5.506c0 9.757-4.491 14.704-13.349 14.704h-11.727c-8.858 0-13.349-4.947-13.349-14.704V.078c0-9.756 4.491-14.703 13.349-14.703h9.508c.493 0 .898-.188 1.239-.572a1.99 1.99 0 00.518-1.368v-13.907c0-.524-.169-.971-.518-1.367-.341-.386-.746-.573-1.239-.573h-6.55c-.494 0-.899.187-1.239.573a1.983 1.983 0 00-.518 1.367v8.134h-14.55v-7.586c0-9.758 4.491-14.705 13.349-14.705H0c8.858 0 13.35 4.947 13.35 14.705v15.221C13.35-5.096 8.86-.148 0 0"
              ></path>
            </g>
            <g transform="translate(370.133 417.896)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c0-.524-.169-.972-.518-1.367-.342-.385-.747-.572-1.239-.572h-5.705c-.494 0-.899.186-1.239.572A1.977 1.977 0 00-9.219 0v41.81h-15.29V1.314c0-9.757 4.491-14.705 13.349-14.705h13.1c8.858 0 13.35 4.948 13.35 14.705V41.81H0z"
              ></path>
            </g>
            <path
              fill="#1a1a18"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M385.423 476.947h-15.29v-11.909h15.29z"
            ></path>
            <path
              fill="#1a1a18"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M360.914 476.947h-15.29v-11.909h15.29z"
            ></path>
            <g transform="translate(420.524 418.553)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0a1.98 1.98 0 00-.519-1.367c-.34-.386-.746-.573-1.238-.573h-8.413v49.431h8.413c.492 0 .898-.187 1.238-.571.35-.396.519-.843.519-1.368zm1.94 58.395h-27.4v-71.347h27.4c8.858 0 13.35 4.947 13.35 14.704V43.69c0 9.757-4.492 14.705-13.35 14.705"
              ></path>
            </g>
            <g transform="translate(461.59 476.947)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h-15.29v-71.347h31.454v13.421H0z"
              ></path>
            </g>
            <path
              fill="#1a1a18"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M484.225 405.601h15.29v71.347h-15.29z"
            ></path>
            <g transform="translate(536.661 478.042)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h-13.311c-8.858 0-13.35-4.947-13.35-14.704v-44.128c0-9.758 4.492-14.705 13.35-14.705H0c8.858 0 13.35 4.947 13.35 14.705v9.447H-1.201v-11.199a1.98 1.98 0 00-.518-1.367c-.342-.386-.747-.573-1.239-.573h-6.655c-.494 0-.899.187-1.24.573-.348.392-.518.84-.518 1.367v47.742c0 .526.17.973.519 1.367.339.385.745.573 1.239.573h6.655c.493 0 .898-.188 1.239-.573.349-.396.518-.843.518-1.367v-8.791H13.35v6.929C13.35-4.947 8.858 0 0 0"
              ></path>
            </g>
            <g transform="translate(584.9 447.272)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h-11.227v29.675h-15.29v-71.347h15.29v27.813H0v-27.813h15.29v71.347H0z"
              ></path>
            </g>
            <g transform="translate(610.255 405.6)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h31.665v13.202H15.29v16.472h15.318V42.22H15.29v16.143h16.375v12.984H0z"
              ></path>
            </g>
            <g transform="translate(720.801 425.313)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0l-7.64 51.421-.031.213h-13.532L-28.874 0l-5.703 51.411-.025.223h-14.883l11.137-71.136.033-.211h17.225l6.653 42.119 6.654-42.119H9.441l11.125 71.058.045.289H5.729z"
              ></path>
            </g>
            <g transform="translate(749.003 405.6)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h31.665v13.202H15.291v16.472h15.318V42.22H15.291v16.143h16.374v12.984H0z"
              ></path>
            </g>
            <path
              fill="#1a1a18"
              fillOpacity="1"
              fillRule="nonzero"
              stroke="none"
              d="M788.725 405.601h15.29v71.347h-15.29z"
            ></path>
            <g transform="translate(840.845 478.042)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h-13.1c-8.858 0-13.349-4.947-13.349-14.704v-57.737h15.289v59.05c0 .528.17.974.519 1.369.34.385.745.573 1.239.573h5.705c.491 0 .896-.188 1.238-.574.349-.395.519-.842.519-1.368v-59.05h15.29v57.737C13.35-4.947 8.858 0 0 0"
              ></path>
            </g>
            <g transform="translate(889.44 449.134)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h-9.508c-.494 0-.899.188-1.239.572a1.987 1.987 0 00-.518 1.368v12.593c0 .526.169.973.518 1.367.34.385.745.573 1.239.573h5.811c.492 0 .897-.188 1.239-.572.349-.396.518-.843.518-1.368V8.698h14.55v5.506c0 9.757-4.491 14.704-13.349 14.704h-11.727c-8.858 0-13.349-4.947-13.349-14.704V.078c0-9.756 4.491-14.703 13.349-14.703h9.508c.493 0 .898-.188 1.238-.572.35-.397.52-.844.52-1.368v-13.907c0-.524-.17-.971-.52-1.368-.34-.385-.745-.572-1.238-.572h-6.55c-.494 0-.899.187-1.239.572a1.987 1.987 0 00-.518 1.368v8.134h-14.55v-7.586c0-9.758 4.491-14.705 13.349-14.705H0c8.858 0 13.351 4.947 13.351 14.705v15.221C13.351-5.096 8.86-.148 0 0"
              ></path>
            </g>
            <g transform="translate(908.1 463.417)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h11.093v-57.816h15.29V0h11.093v13.53H0z"
              ></path>
            </g>
            <g transform="translate(976.45 447.79)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c0-.523-.17-.972-.519-1.367-.34-.386-.746-.573-1.239-.573h-7.566v20.195h7.566c.493 0 .899-.188 1.239-.571.349-.397.519-.844.519-1.369zm1.94 29.158h-26.555v-71.346h15.291v29.017h6.828c1.198 0 1.757-.616 1.757-1.939v-27.078h15.29v28.282c0 4.513-1.645 7.533-4.889 8.986C13.397-3.166 15.29.586 15.29 6.241v8.213c0 9.757-4.491 14.704-13.35 14.704"
              ></path>
            </g>
            <g transform="translate(1026.208 441.688)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h-10.17v23.512c0 .525.17.971.519 1.367.338.385.744.572 1.239.572h6.654c.493 0 .899-.187 1.239-.572A1.99 1.99 0 000 23.512zm1.94 36.354h-14.05c-8.859 0-13.35-4.948-13.35-14.705v-57.737h15.29v23.762H0v-23.762h15.29v57.737c0 9.757-4.491 14.705-13.35 14.705"
              ></path>
            </g>
            <g transform="translate(1077.8 449.134)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h-9.508c-.494 0-.899.188-1.239.572a1.987 1.987 0 00-.518 1.368v12.593c0 .526.169.973.518 1.367.34.385.745.573 1.239.573h5.811c.492 0 .897-.188 1.239-.572.349-.396.518-.843.518-1.368V8.698h14.55v5.506c0 9.757-4.491 14.704-13.349 14.704h-11.727c-8.858 0-13.349-4.947-13.349-14.704V.078c0-9.756 4.491-14.703 13.349-14.703h9.508c.493 0 .898-.188 1.238-.572.35-.397.52-.844.52-1.368v-13.907c0-.524-.17-.971-.52-1.368-.34-.385-.745-.572-1.238-.572h-6.55c-.494 0-.899.187-1.239.572a1.987 1.987 0 00-.518 1.368v8.134h-14.55v-7.586c0-9.758 4.491-14.705 13.349-14.705H0c8.858 0 13.351 4.947 13.351 14.705v15.221C13.351-5.096 8.86-.148 0 0"
              ></path>
            </g>
            <g transform="translate(1126.183 449.134)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h-9.508c-.493 0-.898.188-1.238.573a1.983 1.983 0 00-.519 1.367v12.593c0 .526.17.973.519 1.367.34.385.745.573 1.238.573h5.811c.493 0 .898-.188 1.239-.572a1.99 1.99 0 00.519-1.368V8.698h14.55v5.506c0 9.757-4.491 14.704-13.349 14.704h-11.727c-8.858 0-13.349-4.947-13.349-14.704V.078c0-9.756 4.491-14.703 13.349-14.703h9.508c.492 0 .897-.188 1.238-.572a1.99 1.99 0 00.519-1.368v-13.907c0-.524-.17-.972-.519-1.367-.341-.386-.746-.573-1.238-.573h-6.551c-.493 0-.898.187-1.238.573a1.983 1.983 0 00-.519 1.367v8.134h-14.549v-7.586c0-9.758 4.491-14.705 13.349-14.705H0c8.858 0 13.351 4.947 13.351 14.705v15.221C13.351-5.096 8.86-.148 0 0"
              ></path>
            </g>
            <g transform="translate(1148.752 405.6)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h31.665v13.202H15.291v16.472h15.318V42.22H15.291v16.143h16.374v12.984H0z"
              ></path>
            </g>
            <g transform="translate(1235.265 438.513)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0h-9.324v9.605c0 .525.169.972.517 1.368.34.384.745.572 1.24.572h5.809c.493 0 .899-.188 1.239-.572.349-.397.519-.844.519-1.368zm1.307 22.119h-11.938c-8.858 0-13.349-4.947-13.349-14.704v-26.718c0-9.758 4.491-14.705 13.349-14.705H1.307c8.858 0 13.349 4.947 13.349 14.705v4.41H0v-6.162c0-.524-.17-.971-.519-1.367-.34-.386-.747-.573-1.239-.573h-5.809c-.494 0-.899.187-1.24.573a1.983 1.983 0 00-.517 1.367v10.918h23.98V7.415c0 9.757-4.491 14.704-13.349 14.704"
              ></path>
            </g>
            <g transform="translate(1266.574 420.773)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c-2.173 0-4.046-.8-5.566-2.376-1.519-1.574-2.289-3.512-2.289-5.758 0-2.247.77-4.184 2.289-5.758 1.52-1.577 3.393-2.377 5.566-2.377s4.047.8 5.568 2.377c1.519 1.575 2.289 3.512 2.289 5.758 0 2.245-.77 4.183-2.289 5.758C4.047-.8 2.174 0 0 0"
              ></path>
            </g>
            <g transform="translate(1299.078 426.581)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0l-8.099 50.156-.034.21h-14.885l14.216-71.145.04-.201H8.656l14.197 71.047.059.299H8.133z"
              ></path>
            </g>
            <g transform="translate(1328.574 420.773)">
              <path
                fill="#1a1a18"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c-2.173 0-4.046-.8-5.566-2.376-1.519-1.574-2.289-3.512-2.289-5.758 0-2.247.77-4.184 2.289-5.758 1.52-1.577 3.393-2.377 5.566-2.377s4.047.8 5.568 2.377c1.519 1.575 2.289 3.512 2.289 5.758 0 2.245-.77 4.183-2.289 5.758C4.047-.8 2.174 0 0 0"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Logo;
